import React from 'react'
import { IconInfoDefault } from '@mc/design-system'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { CE_3448_CLARIFY_MULTIPLE_PROFILES_AT_SIGN_UP } from '../hooks/useSignUpEducation'
import i18nInstance from '../i18n/i18nInstance'

export interface ClarifyMultipleProfilesAtSignUpMessageProps {
  className?: string
  location?: 'checkout' | 'default'
}

export const ClarifyMultipleProfilesAtSignUpMessageImpl = ({
  className,
  location = 'default',
}: ClarifyMultipleProfilesAtSignUpMessageProps) => {
  const { t } = useTranslation(
    `@mc/authentication/${CE_3448_CLARIFY_MULTIPLE_PROFILES_AT_SIGN_UP}`,
  )

  // Apply responsive alignment based on location
  const alignmentClasses =
    location === 'checkout'
      ? 'align-items-start align-items-sm-center mc-text--left mc-text-sm--center'
      : 'align-items-start'

  return (
    <div
      className={`mc-bg-container-medium  mc-p-2 mc-corners--2 ${className}`}
      role='note'
      aria-live='polite'
    >
      <div className={`d-flex ${alignmentClasses}`}>
        <span
          aria-hidden
          className='mc-mr-2 mc-opacity--muted d-flex align-items-center'
        >
          <IconInfoDefault width='12' height='12' />
        </span>
        <p className='mc-text-x-small mc-opacity--muted mc-mb-0'>
          {t('message')}
        </p>
      </div>
    </div>
  )
}

export const ClarifyMultipleProfilesAtSignUpMessage = withI18nContext(
  i18nInstance,
)(ClarifyMultipleProfilesAtSignUpMessageImpl)
